import { InjectableService } from "helix-vue-components";
import { Vue } from "vue-property-decorator";
import SecurityPinModalComponent from "./SecurityPinModal/SecurityPin.modal";

export default class SecurityPinService extends InjectableService {
  constructor(app: Vue) {
    super(app);
  }

  /**
   * Opens modal window requesting pin
   * @param title
   * @param description
   */
  public ensure(title?: string, description?: string): Promise<string> {
    return this.openPinModal(title, description);
  }

  private openPinModal(
    title: string = "Security Pin",
    description?: string
  ): Promise<string> {
    return new Promise(async (resolve, reject) => {
      try {
        const pin = await this.$modals.load<string>(
          SecurityPinModalComponent,
          {
            title,
            size: "fit",
            positionY: "top"
          },
          {
            description
          }
        );
        resolve(pin);
      } catch (e) {
        reject(e);
      }
    });
  }
}
